<div class="search-all-results pt-3">
    @for (searchResult of searchResultsList; track searchResult.category) {
        <div class="topic-section mb-3">
            <div class="topic-title pb-12" [textContent]="searchResult.label"></div>
            <div class="d-flex align-items-center justify-content-between pb-1">
                <div class="panel-pagination">
                    <ycn-simple-pagination-controls
                        class="panel-pagination-content"
                        [paginationInfo]="searchResult.resultInfo.paginationInfo"
                        (pageChangeHandler)="pageChanged($event, searchResult.category)">
                    </ycn-simple-pagination-controls>
                </div>
                @if (perPage === 10) {
                    <a class="text-blue text-underline" href="javascript:void(0)"
                    (click)="setCategorySearch(searchResult.category)">View All</a>
                }
            </div>
            <div class="search-all-results-section">
                @for (entry of searchResult.resultInfo.results; track entry.id) {
                    <a class="search-all-results-link row no-gutters" [href]="entry.url">
                        <div class="col-auto width-180 text-bold"
                        [textContent]="entry.display_security_id"></div>
                        <div class="col">
                            {{entry.name}}
                            <div class="text-gray-50">{{entry.desc}}</div>
                        </div>
                    </a>
                }
            </div>
        </div>
    }
</div>
@if (showError){
    <div class="search-all-results pt-3">
        <p>Sorry, there are no results which match that criteria.</p>
        <p>Please try a different term
            @if (!allSearchTypeSelected) {
                <span>or <a href="javascript:void(0)" (click)="resetSearchType()">remove your search filter</a></span>.
            }
        </p>
    </div>
}
